import CrediManagment from "../../components/creditManagement/CreditManagement"


const ManageCredits=()=>{
    return <CrediManagment/>
}

export default ManageCredits